// src/utils/toastConfirm.js
import React from "react";
import { toast } from "react-toastify";

/**
 * Shows a confirm–cancel toast and returns a Promise<boolean>.
 *
 * @param {string} message – text to display in the toast
 * @returns {Promise<boolean>}  true if user clicks Yes, otherwise false
 *
 * Usage:
 *   const ok = await toastConfirm("Delete this item?");
 *   if (ok) { … do the delete … }
 */
export const toastConfirm = (message) =>
  new Promise((resolve) => {
    // We need the ID so we can dismiss the toast manually
    const id = toast.info(
      ({ closeToast }) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            minWidth: 200,
          }}
        >
          <span>{message}</span>

          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={() => {
                resolve(true); // YES
                toast.dismiss(id);
              }}
              style={yesStyle}
            >
              Yes
            </button>
            <button
              onClick={() => {
                resolve(false); // NO
                toast.dismiss(id);
              }}
              style={noStyle}
            >
              No
            </button>
          </div>
        </div>
      ),
      {
        autoClose: false, // stay until user clicks
        closeOnClick: false,
        draggable: false,
      }
    );
  });

// --- tiny inline styles (tweak as you like) -----------------
const btnBase = {
  flex: 1,
  padding: "6px 0",
  border: "none",
  borderRadius: 4,
  cursor: "pointer",
  fontWeight: 600,
};

const yesStyle = {
  ...btnBase,
  background: "#d32f2f",
  color: "#fff",
};

const noStyle = {
  ...btnBase,
  background: "#ccc",
  color: "#000",
};
